import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { SessionProvider } from './lib/session';
import App from './App';
import ErrorBoundary from './lib/ErrorBoundary';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <ErrorBoundary whole>
          <App />
        </ErrorBoundary>
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
